// DatePicker que bloquea sábados, domingos, feriados y días con licencia activa.
// Muestra tooltip con el motivo de bloqueo al pasar el mouse.

import React, { useEffect, useState, useRef } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { Tooltip } from '@mui/material';
import { nodeApiPath } from '../utils/paths';
import { triggerSessionExpired } from '../api/endpoints';

async function jf(path) {
    const token = localStorage.getItem('SIGIF_JWT_TOKEN');
    if (!token) { triggerSessionExpired(); throw new Error('No token'); }
    const res = await fetch(nodeApiPath(path), { headers: { Authorization: `Bearer ${token}` } });
    if (res.status === 401) { triggerSessionExpired(); throw new Error('Token expirado'); }
    return await res.json();
}

function CustomDay(props) {
    const { day, bloqueados, ...other } = props;
    if (!day) return <PickersDay {...other} day={day} />;

    const dow = day.getDay();
    const iso = day.toISOString().substring(0, 10);
    const esFinDeSemana = dow === 0 || dow === 6;
    const motivoBloqueo = bloqueados[iso] || null;
    const bloqueado = esFinDeSemana || !!motivoBloqueo;

    const tooltip = esFinDeSemana
        ? (dow === 0 ? 'Domingo' : 'Sábado')
        : motivoBloqueo || '';

    const dayElement = (
        <PickersDay
            {...other}
            day={day}
            disabled={bloqueado}
            sx={{
                ...(motivoBloqueo && !esFinDeSemana ? {
                    bgcolor: motivoBloqueo.startsWith('Feriado') ? '#fff3e0' : '#e3f2fd',
                    color: motivoBloqueo.startsWith('Feriado') ? '#e65100' : '#1565c0',
                    '&.Mui-disabled': {
                        color: motivoBloqueo.startsWith('Feriado') ? '#e65100' : '#1565c0',
                        bgcolor: motivoBloqueo.startsWith('Feriado') ? '#fff3e0' : '#e3f2fd',
                    },
                } : {}),
            }}
        />
    );

    if (bloqueado && tooltip) {
        return (
            <Tooltip title={tooltip} arrow placement="top">
                <span>{dayElement}</span>
            </Tooltip>
        );
    }

    return dayElement;
}

export default function FechaBloqueada({ label, value, onChange, minDate, size = 'small', fullWidth = true, sx }) {
    const [bloqueados, setBloqueados] = useState({});
    const cacheRef = useRef({});

    const cargarMes = async (year, month) => {
        const key = `${year}-${month}`;
        if (cacheRef.current[key]) {
            setBloqueados(prev => ({ ...prev, ...cacheRef.current[key] }));
            return;
        }
        const desde = `${year}-${String(month).padStart(2, '0')}-01`;
        const hasta = `${year}-${String(month).padStart(2, '0')}-${new Date(year, month, 0).getDate()}`;
        try {
            const r = await jf(`personal/dias-bloqueados?desde=${desde}&hasta=${hasta}`);
            if (r.ok) {
                cacheRef.current[key] = r.bloqueados || {};
                setBloqueados(prev => ({ ...prev, ...(r.bloqueados || {}) }));
            }
        } catch { }
    };

    useEffect(() => {
        const hoy = new Date();
        for (let d = -1; d <= 2; d++) {
            const m = new Date(hoy.getFullYear(), hoy.getMonth() + d, 1);
            cargarMes(m.getFullYear(), m.getMonth() + 1);
        }
    }, []);

    const dateVal = value ? new Date(value + 'T12:00:00') : null;

    return (
        <DatePicker
            label={label}
            value={dateVal}
            onChange={(d) => {
                if (!d) { onChange(''); return; }
                const iso = d.toISOString().substring(0, 10);
                onChange(iso);
            }}
            minDate={minDate ? new Date(minDate + 'T12:00:00') : undefined}
            onMonthChange={(d) => {
                if (!d) return;
                cargarMes(d.getFullYear(), d.getMonth() + 1);
            }}
            slots={{ day: CustomDay }}
            slotProps={{
                day: { bloqueados },
                textField: { size, fullWidth, sx },
            }}
            format="dd/MM/yyyy"
        />
    );
}
